export default {
    status: {
        REGISTERED_ONLINE: 'Pendiente',
        REGISTERED_EMAIL: 'Pendiente',
        REGISTERED_POSTAL: 'Pendiente',
        REGISTERED: 'Pendiente',
        SIGNED: 'Firmada',
        VALIDATED: 'Validada',
        RD_SENT: 'Enviada',
        SNCE_1: 'SNCE 1',
        SNCE_2: 'SNCE 2',
        SNCE_3: 'SNCE 3',
        PERIODIC_ACTIVE: 'Periódica Activa',
        CANCELLED: 'Anulada',
        FINALIZED: 'Finalizada',
        PERIODIC_SUSPENDED: 'Periódica suspendida'
    },
    products: {
        P: {
            COBAS_GLOBAL: 'Cobas Global PP',
            COBAS_MIXTO_GLOBAL: 'Cobas Mixto Global PP'
        },
        F: {
            COBAS_SELECCION: 'Cobas Selección FI',
            COBAS_INTERNACIONAL: 'Cobas Internacional FI',
            COBAS_IBERIA: 'Cobas Iberia FI',
            COBAS_GRANDES_COMPANIAS: 'Cobas Grandes Compañías FI',
            COBAS_RENTA: 'Cobas Renta FI',
            COBAS_CONCENTRADOS_FIL: 'Cobas Concentrados FI'
        },
        all: {
            COBAS_GLOBAL: 'Cobas Global PP',
            COBAS_MIXTO_GLOBAL: 'Cobas Mixto Global PP',
            COBAS_SELECCION: 'Cobas Selección FI',
            COBAS_INTERNACIONAL: 'Cobas Internacional FI',
            COBAS_IBERIA: 'Cobas Iberia FI',
            COBAS_GRANDES_COMPANIAS: 'Cobas Grandes Compañías FI',
            COBAS_RENTA: 'Cobas Renta FI',
            COBAS_CONCENTRADOS_FIL: 'Cobas Concentrados FI'
        },
        RD_codes: {
            '10392': 'Cobas Selección FI',
            '10393': 'Cobas Renta FI',
            '10394': 'Cobas Grandes Compañías FI',
            '10395': 'Cobas Internacional FI',
            '10396': 'Cobas Iberia FI',
            '10397': 'Cobas Concentrados FI',
            '64678': 'Cobas Global PP',
            '64680': 'Cobas Mixto Global PP',
            '64682': 'Cobas Empleo PP',
            '75151': 'Cobas Selección FI clase A',
            '75152': 'Cobas Selección FI clase B',
            '75153': 'Cobas Selección FI clase C',
            '75154': 'Cobas Selección FI clase D',
            '75155': 'Cobas Grandes Compañías FI A',
            '75156': 'Cobas Grandes Compañías FI B',
            '75157': 'Cobas Grandes Compañías FI C',
            '75158': 'Cobas Grandes Compañías FI D',
            '75159': 'Cobas Internacional FI clase A',
            '75160': 'Cobas Internacional FI clase B',
            '75161': 'Cobas Internacional FI clase C',
            '75162': 'Cobas Internacional FI clase D',
            '75163': 'Cobas Iberia FI clase A',
            '75164': 'Cobas Iberia FI clase B',
            '75165': 'Cobas Iberia FI clase C',
            '75166': 'Cobas Iberia FI clase D',
            '75167': 'Cobas Concentrados FI clase A',
            '75168': 'Cobas Concentrados FI clase B',
            '75169': 'Cobas Concentrados FI clase C',
            '75170': 'Cobas Concentrados FI clase D'
        },
        COBAS_SELECCION: 'Cobas Selección FI',
        COBAS_SELECCION_A: 'Cobas Selección FI A',
        COBAS_SELECCION_B: 'Cobas Selección FI B',
        COBAS_SELECCION_C: 'Cobas Selección FI C',
        COBAS_SELECCION_D: 'Cobas Selección FI D',
        COBAS_INTERNACIONAL: 'Cobas Internacional FI',
        COBAS_INTERNACIONAL_A: 'Cobas Internacional FI A',
        COBAS_INTERNACIONAL_B: 'Cobas Internacional FI B',
        COBAS_INTERNACIONAL_C: 'Cobas Internacional FI C',
        COBAS_INTERNACIONAL_D: 'Cobas Internacional FI D',
        COBAS_IBERIA: 'Cobas Iberia FI',
        COBAS_IBERIA_A: 'Cobas Iberia FI A',
        COBAS_IBERIA_B: 'Cobas Iberia FI B',
        COBAS_IBERIA_C: 'Cobas Iberia FI C',
        COBAS_IBERIA_D: 'Cobas Iberia FI D',
        COBAS_GRANDES_COMPANIAS: 'Cobas Grandes Compañías FI',
        COBAS_GRANDES_COMPANIAS_A: 'Cobas Grandes Compañías FI A',
        COBAS_GRANDES_COMPANIAS_B: 'Cobas Grandes Compañías FI B',
        COBAS_GRANDES_COMPANIAS_C: 'Cobas Grandes Compañías FI C',
        COBAS_GRANDES_COMPANIAS_D: 'Cobas Grandes Compañías FI D',
        COBAS_RENTA: 'Cobas Renta FI',
        COBAS_GLOBAL: 'Cobas Global PP',
        COBAS_MIXTO_GLOBAL: 'Cobas Mixto Global PP',
        COBAS_CONCENTRADOS_FIL: 'Cobas Concentrados FI',
        COBAS_CONCENTRADOS_FIL_A: 'Cobas Concentrados FI A',
        COBAS_CONCENTRADOS_FIL_B: 'Cobas Concentrados FI B',
        COBAS_CONCENTRADOS_FIL_C: 'Cobas Concentrados FI C',
        COBAS_CONCENTRADOS_FIL_D: 'Cobas Concentrados FI D',
        COBAS_MIXTO_GLOBAL_FP: 'Cobas Mixto Global PP',
        COBAS_GLOBAL_FP: 'Cobas Global PP',
        COBAS_VALUE_SICAV: 'Cobas Value SICAV SA',
        LUX_INTERNATIONAL_EUR: 'Cobas LUX SICAV Cobas International Fund (EUR)',
        LUX_INTERNATIONAL_USD: 'Cobas LUX SICAV Cobas International Fund (USD)',
        LUX_LARGE_CAP_EUR: 'Cobas LUX SICAV Cobas Large Cap Fund (EUR)',
        LUX_SELECTION_EUR: 'Cobas LUX SICAV Cobas Selection Fund (EUR)',
        LUX_SELECTION_USD: 'Cobas LUX SICAV Cobas Selection Fund (USD)',
        SURNE_COBAS_100: 'Surnepensión Cobas 100',
        SURNE_COBAS_50: 'Surnepensión Cobas 50/50',
        COBAS_AUTONOMOS_EMPLEO: 'Cobas Autónomos PPES',
        COBAS_AUTONOMOS_RENTA: 'Cobas Autónomos Renta PPES',
        COBAS_EMPLEO: 'Cobas Empleo 100 PPE'
    },
    operations_types: {
        P: {
            SOLICITUD_APORTACION_PERIODICA: 'Solicitud de Aportación Periódica',
            APORTACION: 'Aportación',
            APORTACION_PERIODICA: 'Aportación Periódica',
            TRASPASO_ENTRADA: 'Traspaso de entrada',
            TRASPASO_INTERNO: 'Traspaso Interno',
            RESCATE: 'Rescate'
        },
        F: {
            SUSCRIPCION: 'Suscripción',
            SOLICITUD_SUSCRIPCION_PERIODICA: 'Solicitud de Suscripción Periódica',
            TRASPASO_ENTRADA: 'Traspaso de entrada',
            TRASPASO_INTERNO: 'Traspaso Interno',
            REEMBOLSO: 'Reembolso',
            REEMBOLSO_PERIODICO: 'Reembolso Periódico',
            SOLICITUD_REEMBOLSO_PERIODICO: 'Solicitud de Reembolso Periódico'
        },
        all: {
            SOLICITUD_APORTACION_PERIODICA: 'Solicitud de Aportación Periódica',
            APORTACION: 'Aportación',
            APORTACION_PERIODICA: 'Aportación Periódica',
            TRASPASO_INTERNO: 'Traspaso Interno',
            SUSCRIPCION: 'Suscripción',
            SOLICITUD_SUSCRIPCION_PERIODICA: 'Solicitud de Suscripción Periódica',
            REEMBOLSO: 'Reembolso',
            REEMBOLSO_PERIODICO: 'Reembolso Periódico',
            SOLICITUD_REEMBOLSO_PERIODICO: 'Solicitud de Reembolso Periódico',
            RESCATE: 'Rescate',
            TRASPASO_ENTRADA: 'Traspaso de entrada',
            TRASPASO_SALIDA: 'Traspaso de salida',
            DESBLOQUEO_PARTICIPACIONES: 'Desbloqueo de participaciones',
            BLOQUEO_PARTICIPACIONES: 'Bloqueo de participaciones',
            DEVOLUCION_EXCESO: 'Devolución de exceso',
            HERENCIA_ENTRADA: 'Herencia de entrada',
            HERENCIA_SALIDA: 'Herencia de salida',
            DONACION_ENTRADA: 'Donación de Entrada',
            DONACION_SALIDA: 'Donación de Salida',
            CONTINGENCIA_ENTRADA: 'Entrada de Saldo por Contingencia',
            CONTINGENCIA_SALIDA: 'Salida de Saldo por Contingencia'
        },
        info: {
            SUSCRIPCION:
                'Recuerde que el valor liquidativo aplicado a una operación de suscripción se corresponderá con el día en el cual se haya conciliado el importe en cuenta con la orden correspondiente.',
            REEMBOLSO:
                'El valor liquidativo aplicable a una orden de reembolso será el del mismo día de la fecha de solicitud, siempre que la orden se curse antes de las 14:00 horas en día hábil a efectos de valoración del fondo. En el caso de que la fecha seleccionada sea un día inhábil pasará al siguiente día hábil a efectos de valoración del fondo. Inversión mínima a mantener: 100 Euros. No será de aplicación a participaciones del fondo o de FI de renta variable de la gestora adquiridas con anterioridad al 05/07/2019 que será de una participación.',
            SOLICITUD_SUSCRIPCION_PERIODICA:
                'En el caso de la suscripción periódica si la fecha seleccionada es un día inhábil pasará al siguiente día hábil a efectos de valoración del fondo',
            SOLICITUD_REEMBOLSO_PERIODICO:
                'El valor liquidativo aplicable a una orden de reembolso será el del mismo día de la fecha de solicitud, siempre que la orden se curse antes de las 14:00 horas en día hábil a efectos de valoración del fondo. En el caso de que la fecha seleccionada sea un día inhábil pasará al siguiente día hábil a efectos de valoración del fondo. Inversión mínima a mantener: 100 Euros. No será de aplicación a participaciones del fondo o de FI de renta variable de la gestora adquiridas con anterioridad al 05/07/2019 que será de una participación.',
            TRASPASO_INTERNO:
                'Recuerde que al seleccionar esta opción se pierde un día de valor en su cartera entre la fecha valor de salida del fondo de origen y la fecha valor de entrada en el fondo de destino, excepto para traspasos internos con destino Cobas Concentrados F.I.L.'
        }
    },
    sub_operations_types: {
        all: {
            TC: 'Traspaso de clase',
            B: 'Bloqueo Manual',
            P: 'Pignoración | Herencia Pago Gananciales | Prestación',
            I: 'Traspaso Interno',
            E: 'Traspaso Externo',
            S: 'Canje',
            R: 'Separación de bienes',
            C: 'Capitulación',
            T: 'Cambio Titularidad',
            O: 'Cambio Comercializador | Otros',
            N: 'Testamentaría',
            D: 'Disolución',
            L: 'Disolución Sociedad Gananciales',
            F: 'Fusión',
            H: 'Herencia',
            G: 'Renta Obligatoria',
            V: 'Prestaciones con Reversión',
            A: 'Actuarial',
            J: 'Baja',
            AP: 'Aportación con Prestación'
        }
    },
    indicators: {
        I: 'Importe neto',
        B: 'Importe bruto',
        P: 'Participaciones',
        T: 'Total'
    },
    pay_methods: {
        DOMICILIACION: 'Domiciliacion',
        TRANSFERENCIA: 'Transferencia',
        CHEQUE: 'Cheque'
    },
    rights_types: {
        C: 'Derechos consolidados',
        E: 'Derechos económicos',
        A: 'Ambos'
    },
    source_situations: {
        PARTICIPE: 'Participe',
        BENEFICIARIO: 'Beneficiario'
    },
    compartments: {
        1: 'Anteriores a 2007',
        2: 'Posteriores a 2006',
        3: 'De ambos'
    },
    retirement_plan_type: {
        PPA: 'Plan de previsión asegurado (PPA)',
        PP: 'Plan de pensiones (PP)'
    },
    periodicity_options: {
        MENSUAL: 'Mensual',
        TRIMESTRAL: 'Trimestral',
        SEMESTRAL: 'Semestral',
        ANUAL: 'Anual'
    },
    periodic_order_disclaimer: {
        F: '<b>Importante:</b> Para mantener activa su orden de suscripción periódica, deberá realizar el ingreso correspondiente de acuerdo con la periodicidad seleccionada (mensual, trimestral, semestral o anual). Si transcurrido el periodo correspondiente y 10 días adicionales no se ha recibido el importe previsto, la orden periódica será cancelada automáticamente.',
        P: '<b>Importante:</b> Para mantener activa su orden de aportación periódica, deberá realizar el ingreso correspondiente de acuerdo con la periodicidad seleccionada (mensual, trimestral, semestral o anual). Si transcurrido el periodo correspondiente y 10 días adicionales no se ha recibido el importe previsto, la orden periódica será cancelada automáticamente.'
    },
    revaluation_options: {
        'no-increase': 'Sin incremento',
        LINEAL: 'Lineal',
        PORCENTUAL: 'Porcentual',
        ACUMULATIVO: 'Acumulativo'
    },
    redemption_defers: {
        DIFERIDO: 'Diferido',
        NO_DIFERIDO: 'No diferido'
    },
    redemption_collection_methods: {
        TOTAL: 'Totalidad del capital',
        MIXTA: 'Renta Mixta',
        FINANCIERA: 'Renta financiera',
        OTRAS: 'Otras'
    },
    redemption_causes: {
        JUBILACION: 'Jubilación',
        INVALIDEZ: 'Invalidez',
        DEPENDENCIA: 'Dependencia',
        ENFERMEDAD_GRAVE: 'Enfermedad grave',
        DESEMPLEO: 'Desempleo',
        VARIACION_PRESTACION: 'Variación prestación',
        FALLECIMIENTO: 'Fallecimiento'
    },
    purchase_key_operation_type: {
        APORTACION: 'Aportación',
        SUSCRIPCION: 'Suscripción',
        HERENCIA_ENTRADA: 'Herencia',
        DONACION_ENTRADA: 'Donación',
        TRASPASO_ENTRADA: 'Traspaso'
    },
    tx_collection_methods: {
        1: 'Todas las formas de cobro',
        2: 'Capital diferido',
        3: 'Renta financiera',
        4: 'Pagos sin periocidad regular'
    },
    rendering_variation_types: {
        INCREMENTO_RENTA: 'Incremento de la renta',
        DISMINUCION_RENTA: 'Disminución de la renta',
        ADELANTO_COBRO: 'Adelanto del cobro de capital'
    }
};
